import React from 'react'

export default function RenderTexto(dados) {
    const estilo = { fontSize: "larger", fontWeight: 500, textAlign: "left", padding: "30px 0 0 60px" }
    if (dados.data) {
        let dia = dados.data.slice(8)
        let mes = dados.data.slice(5, 7)
        let ano = dados.data.slice(0, 4)
        var data = `${dia}/${mes}/${ano}`
    }
    else var data = null
    if (dados.tipo === "DESCUMPRIMENTO DA RESOLUÇÃO 139/92 - ATENDIMENTO DA DETERMINAÇÃO") {
        return (
            <div>
                <div style={estilo}>
                    DESCUMPRIMENTO DA RESOLUÇÃO 139/92 - Atendimento da Determinação
                </div>
                <div className="paragrafo">
                    Ato fiscalizatório realizado em {data} identificou descumprimento da Resolução COFFITO 139/92, em razão da ausência de designação de responsável técnico pelo serviço, tendo sido facultado prazo de 15 dias para nomeação.
                    Consoante certidão nos autos a determinação foi atendida pela empresa.
                    Encaminho o processo para arquivo.
                </div>
            </div>
        )
    }
    else if (dados.tipo === "DESCUMPRIMENTO DA RESOLUÇÃO 139/92 – NÃO ATENDIMENTO DA DETERMINAÇÃO") {
        return (
            <div>
                <div style={estilo}>
                    DESCUMPRIMENTO DA RESOLUÇÃO 139/92 – NÃO ATENDIMENTO DA DETERMINAÇÃO
                </div>
                <div className="paragrafo">
                    Ato fiscalizatório realizado em {data} identificou descumprimento da Resolução COFFITO 139/92, em razão da ausência de designação de responsável técnico pelo serviço, tendo sido facultado prazo de 15 dias para nomeação, que transcorreu sem manifestação.
                    Assim, encaminho o processo à Presidência para análise e encaminhamentos, opinando esta coordenação pela notificação, por Oficio GAPRE, aos membros da equipe assistencial, informando-os do desempenho da reponsabilidade solidária pelo cumprimento das normas profissionais, na ausência de responsável técnico designado.
                </div>
            </div>
        )
    }
    else if (dados.tipo === "DESCUMPIRMENTO DA RESOLUÇÃO COFFITO 08/1978 – DO ATENDIMENTO") {
        return (
            <div>
                <div style={estilo}>
                    DESCUMPIRMENTO DA RESOLUÇÃO COFFITO 08/1978 – DO ATENDIMENTO
                </div>
                <div className="paragrafo">
                    Ato fiscalizatório realizado em {data} identificou descumprimento da Resolução COFFITO 08/78, em seu artigo 105, face a ausência de registro de consultório, tendo sido lavrado auto de infração em desfavor do profissional em tela, com fixação de prazo administrativo de 15 dias para correção da irregularidade.
                    Consoante certidão constante nos autos o registro foi realizado sob n.º {dados.numeroCertidao}
                </div>
            </div>
        )
    }
    else if (dados.tipo === "DESCUMPIRMENTO DA RESOLUÇÃO COFFITO 08/1978 – DO NÃO ATENDIMENTO") {
        return (
            <div>
                <div style={estilo}>
                    DESCUMPIRMENTO DA RESOLUÇÃO COFFITO 08/1978 – DO NÃO ATENDIMENTO
                </div>
                <div className="paragrafo">
                    Ato fiscalizatório realizado em {data} identificou descumprimento da Resolução COFFITO 08/78, em seu artigo 105, face a ausência de registro de consultório, tendo sido lavrado auto de infração em desfavor do profissional em tela, com fixação de prazo administrativo de 15 dias para correção da irregularidade, que transcorreu sem manifestação.
                    Assim, encaminho à Presidência para análise e providências, entendendo esta Coordenação, a necessidade de notificação por Oficio GAPRE da obrigação de realizar o registro de consultório, sob pena de instauração de processo ético em seu desfavor.
                </div>
            </div>
        )
    }
    else if (dados.tipo === "DESCUMPRIMENTO DA RESOLUÇÃO COFFITO 37/84 – DO NÃO ATENDIMENTO") {
        return (
            <div>

                <div style={estilo}>
                    DESCUMPRIMENTO DA RESOLUÇÃO COFFITO 37/84 – DO NÃO ATENDIMENTO
                </div>
                <div className="paragrafo">
                    Ato fiscalizatório realizado em {data} identificou descumprimento da Resolução COFFITO 37/84, em razão da ausência de registro de empresa junto a este regional, tendo sido lavrado auto de infração, com fixação de prazo de 30 dias para cumprimento da obrigação, tendo transcorrido sem manifestação da parte interessada.
                    Assim, encaminho à Presidência para análise e providências, opinando esta coordenação pela notificação por Oficio GAPRE a {dados.proprietario}, proprietário(a) da empresa, conforme informações constantes no termo de visita, para que cumpra a obrigação de realização do registro, sob pena de instauração de processo ético em seu desfavor.
                </div>
            </div>
        )
    }
    else if (dados.tipo === "DESCUMPRIMENTO DA RESOLUÇÃO COFFITO 37/84 – DO ATENDIMENTO") {
        return (
            <div>
                <div style={estilo}>
                    DESCUMPRIMENTO DA RESOLUÇÃO COFFITO 37/84 – DO ATENDIMENTO
                </div>
                <div className="paragrafo">
                    Ato fiscalizatório realizado em {data} identificou descumprimento da Resolução COFFITO 37/84, em razão da ausência de registro de empresa junto a este regional, tendo sido lavrado auto de infração, com fixação de prazo de 30 dias para cumprimento da obrigação.
                    Certidão constante nos autos aponta para cumprimento da obrigação, tendo sido registrado sob n.º {dados.numeroCertidao}.
                </div>
            </div>
        )
    }
    else if (dados.tipo === "DESCUMPRIMENTO DA RESOLUÇÃO COFFITO 37/84- ATIVIDADE SECUNDÁRIA") {
        return (
            <div>
                <div style={estilo}>
                    DESCUMPRIMENTO DA RESOLUÇÃO COFFITO 37/84- ATIVIDADE SECUNDÁRIA
                </div>
                <div className="paragrafo">
                    Consoante entendimento da assessoria jurídica desta autarquia, constante em parecer, encaminho o processo para o setor administrativo para que extraia os documentos e informações necessárias para realização do cadastro compulsório da empresa em epígrafe e envie ao setor de registro para efetivação.
                    Concluído o cadastro, seja a empresa em tela notificada da necessidade de nomeação de responsável técnico pelo serviço de fisioterapia ou terapia ocupacional no prazo de 15 dias.
                    Permanecendo inerte, sejam notificados por oficio GAPRE todos os profissionais componentes da equipe da responsabilidade ética solidária pela condução do serviço consoante prevê as normas profissionais.
                </div>
            </div>
        )
    }
    else if (dados.tipo === "DESCUMPRIMENTO DA RESOLUÇÃO COFFITO 414 E/OU 415/12 (Sem AI)") {
        return (
            <div>
                <div style={estilo}>
                    DESCUMPRIMENTO DA RESOLUÇÃO COFFITO 414 E/OU 415/12
                </div>
                <div className="paragrafo">
                    Ato fiscalizatório realizado em {data} identificou descumprimento da Resolução COFFITO {dados.resolucao}, em razão da inadequação do registro em prontuário.
                    A atuação de caráter pedagógico é indissociável na busca da qualificação assistencial.
                    Assim considerando os princípios da economicidade e efetividade ínsitos à administração pública, opino pelo convite do(a)
                    profissional orientado(a) para que realize o curso de elaboração de prontuários disponibilizado pela autarquia por
                    intermédio da EDUCA CREFITO-1.
                    Enviado o convite por endereço eletrônico do profissional, seja encaminhado o processo
                    para arquivo. À Presidência para análise.
                </div>
            </div>
        )
    }
    else if (dados.tipo === "DESCUMPRIMENTO DA RESOLUÇÃO COFFITO 414 E/OU 415/12") {
        return (
            <div>
                <div style={estilo}>
                    DESCUMPRIMENTO DA RESOLUÇÃO COFFITO 414 E/OU 415/12
                </div>
                <div className="paragrafo">
                    Ato fiscalizatório realizado em {data} identificou descumprimento da Resolução COFFITO {dados.resolucao}, em razão da inadequação do registro em prontuário.
                    A atuação de caráter pedagógico é indissociável na busca da qualificação assistencial. Assim considerando os princípios da economicidade e efetividade ínsitos à administração pública, opino pela convocação da profissional atuada para que realize o curso de elaboração de prontuários disponibilizado pela autarquia por intermédio da EDUCA CREFITO-1, participando da atividade seja o auto de infração emitido, anulado.
                    Caso a profissional convocada não participe do curso, seja o processo encaminhado a Diretoria para apreciação da pertinência de instauração de processo ético.
                    À Presidência para análise.
                </div>
            </div>
        )
    }
    else if (dados.tipo === "ALTERAÇÃO DE DADOS CADASTRAIS") {
        return (
            <div>
                <div style={estilo}>
                    ALTERAÇÃO DE DADOS CADASTRAIS
                </div>
                <div className="paragrafo">
                    Encaminho ao setor administrativo para que extraia cópia do Termo de Visita e encaminhe à Recepção para protocolo para que o setor de registro realizar as alterações cadastrais apontadas como desatualizadas pela fiscal técnica.
                    Ato contínuo encaminhe o processo para arquivo.
                </div>
            </div>
        )
    }
    else if (dados.tipo === "ATO FISCALIZATÓRIO NÃO REALIZADO") {
        return (
            <div>
                <div style={estilo}>
                    ATO FISCALIZATÓRIO NÃO REALIZADO
                </div>
                <div className="paragrafo">
                    Ato fiscalizatório não foi realizado.
                    Encaminho o processo para arquivo.
                    Inserir em rota ordinária de fiscalização conforme fluxo do DEFIS.
                </div>
            </div>
        )
    }
    else if (dados.tipo === "SERVIÇO SEM IRREGULARIDADES") {
        return (
            <div>
                <div style={estilo}>
                    SERVIÇO SEM IRREGULARIDADES
                </div>
                <div className="paragrafo">
                    Ato fiscalizatório realizado em {data} no serviço em epígrafe não encontrou irregularidades.
                    Encaminho o processo para arquivo.
                </div>
            </div>
        )
    }
    else if (dados.tipo === "SERVIÇO DESATIVADO SEM REGISTRO") {
        return (
            <div>
                <div style={estilo}>
                    SERVIÇO DESATIVADO SEM REGISTRO
                </div>
                <div className="paragrafo">
                    Visita ao endereço cadastrado no sistema da autarquia identificou a desativação do serviço.
                    Não há registro vinculado à autarquia profissional.
                    Encaminho o processo para arquivo.
                </div>
            </div>
        )
    }
    else if (dados.tipo === "EM BRANCO") {
        return (
            <div className="paragrafo">{dados.textoBranco}</div>
        )
    }
    else if (dados.tipo === "ESTABELECIMENTO SEM EQUIPE PRÓPRIA") {
        return (
            <div>
                <div style={estilo}>
                    ESTABELECIMENTO SEM EQUIPE PRÓPRIA
                </div>
                <div className="paragrafo">
                    Ato fiscalizatório identificou que o estabelecimento em epígrafe não dispõe de equipe própria,
                    prestando o serviço assistencial por intermédio de locação de espaço às profissionais
                    identificadas no termo de visita em tela, cuja fiscalização do exercício profissional ocorreu
                    em processo administrativo fiscal próprios. Assim, encaminho o processo para arquivo.
                </div>
            </div>
        )
    }
    else if (dados.tipo === "DESCUMPRIMENTO DA RDC 07/2010 – ANVISA") {
        return (
            <div>
                <div style={estilo}>
                    DESCUMPRIMENTO DA RDC 07/2010 – ANVISA
                </div>
                <div className="paragrafo">
                    Ato fiscalizatório realizado em {data} no estabelecimento em epígrafe
                    identificou descumprimento da RDC 07/2010 da ANVISA, no que tange a {dados.textoBranco}.
                    Assim, consoante entendimento da Presidência deste Regional, encaminho à
                    Ajur para análise e providências.
                </div>
            </div>
        )
    }
    else if (dados.tipo === "ATRIBUIÇÕES EXTRA COMPETÊNCIA PROFISSIONAL") {
        return (
            <div className="paragrafo">
                Ato fiscalizatório realizado no dia {data} identificou atuação do
                fisioterapeuta/terapeuta ocupacional fora do seu escopo de competência, {dados.textoBranco}. Assim, encaminho o processo à Presidência,
                opinando pela notificação a responsável técnica, para que cesse a prática irregular.
            </div>
        )
    }
    else if (dados.tipo === "PRESTAÇÃO DE ASSISTÊNCIA EM HOME CARE") {
        return (
            <div className="paragrafo">
                Inspeção técnica no endereço cadastrado na autarquia como sede do estabelecimento funciona
                apenas como caixa postal, restando mitigado o ato fiscalizatório.
                Diligências efetuadas identificaram que a empresa atua apenas em âmbito domiciliar.
                Encaminho o processo para arquivo.
            </div>
        )
    }
    else if (dados.tipo === "SERVIÇO NÃO DISPÕE DE ASSISTÊNCIA") {
        let profissao = dados.profissao || "fisioterapia/terapia ocupacional"
        return (
            <div className="paragrafo">
                Inspeção técnica realizada identificou que o estabelecimento não dispõe de assistência da {profissao}. Encaminho o processo para arquivo.
            </div>
        )
    }
    else if (dados.tipo === "SERVIÇO DESATIVADO COM SOLICITAÇÃO DE BAIXA DE REGISTRO") {
        return (
            <div className="paragrafo">
                Visita técnica identificou a desativação do serviço, com posterior requerimento de baixa do
                registro de consultório/empresa. Encaminho o processo para arquivo.
            </div>
        )
    }
    else if (dados.tipo === "SERVIÇO DESATIVADO SEM REQUERIMENTO DE BAIXA DE REGISTRO") {
        return (
            <div className="paragrafo">
                Visita técnica identificou a desativação do serviço em tela, tendo o profissional
                permanecido inerte após notificação para realização do requerimento de baixa de registro de
                consultório/empresa. Assim, encaminho ao setor administrativo para que extraia os
                documentos necessários para remessa ao setor de registro para que realize a baixa compulsória
                do registro em tela. Ato contínuo, encaminho o processo para arquivo.
            </div>
        )
    }
}